import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { EVENTO, chaveDoSegmento, lerSegmento } from "./segmento";

// Irmao do useTextos do modulo de Checklist (AUD-C), para as telas do Painel
// de Gestao, que ficam fora do WorkshopProvider. Devolve um t() que tenta a
// variante de moto e cai no texto original quando ela nao existe.
//
// Uso: const { tSeg } = useTextosSegmento();  -- e trocar t( por tSeg( SO nas
// chamadas de vocabulario de veiculo. Todo o resto da tela continua no t()
// normal, intocado.
export default function useTextosSegmento() {
  const { t, i18n } = useTranslation();
  const [segmento, setSegmento] = useState(lerSegmento);

  useEffect(() => {
    const aoMudar = () => setSegmento(lerSegmento());
    window.addEventListener(EVENTO, aoMudar);
    return () => window.removeEventListener(EVENTO, aoMudar);
  }, []);

  const tSeg = useCallback(
    (chave, ...resto) => t(chaveDoSegmento(i18n, chave, segmento), ...resto),
    [t, i18n, segmento]
  );

  return { tSeg, t, segmento };
}

// Versao sem React, para os exportadores de CSV e de relatorio HTML da O.S.,
// que sao funcoes de modulo e nao podem chamar hook.
export function tSegDireto(i18n, chave, ...resto) {
  return i18n.t(chaveDoSegmento(i18n, chave, lerSegmento()), ...resto);
}
